/* ================================================================
   MAISON NOIRE — main.js (Shopify Edition)
   All animations, interactions, and Shopify cart integration
================================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ================================================================
  //  LOGO INJECTION (reads from section settings data element)
  // ================================================================
  const logoData = document.getElementById('site-logo-data');
  if (logoData) {
    const logoSrc   = logoData.dataset.src;
    const logoWidth = parseInt(logoData.dataset.width) || 160;
    const logoHTML  = `<img src="${logoSrc}" alt="" class="nav-logo-img" style="height:auto;max-width:${logoWidth}px;filter:brightness(0) invert(1);">`;

    const navLogo = document.getElementById('navLogo');
    if (navLogo) navLogo.innerHTML = logoHTML;

    const loaderBrand = document.getElementById('loaderBrand');
    if (loaderBrand) {
      loaderBrand.innerHTML = `<img src="${logoSrc}" alt="" class="loader-logo-img" style="width:${logoWidth}px;max-width:90vw;height:auto;opacity:0;transform:translateY(16px);filter:brightness(0) invert(1);">`;
    }
  }

  const isHomepage = !!document.getElementById('loader');

  // ================================================================
  //  LOADER (homepage only)
  // ================================================================
  if (isHomepage) {
    const loader    = document.getElementById('loader');
    const loaderBar = document.getElementById('loaderBar');
    const loaderPct = document.getElementById('loaderPct');

    let progress = 0;
    let loaderReady = false;
    let progressDone = false;
    const loaderStartTime = Date.now();
    const MIN_DISPLAY_MS = 3000;

    const hasLogoImg = !!document.querySelector('.loader-logo-img');
    const introTl = anime.timeline({ easing: 'easeOutExpo' });

    if (hasLogoImg) {
      introTl
        .add({ targets: '.loader-logo-img', opacity: [0, 1], translateY: [16, 0], duration: 900 })
        .add({ targets: '.loader-rule', width: [0, 180], duration: 700, easing: 'easeInOutQuart' }, '-=300')
        .add({
          targets: '.loader-bar-wrap',
          opacity: [0, 1],
          duration: 400,
          complete: () => { loaderReady = true; maybeHide(); }
        }, '-=100');
    } else {
      introTl
        .add({ targets: '.loader-m', opacity: [0, 1], translateY: [12, 0], duration: 800 })
        .add({ targets: '.loader-n', opacity: [0, 1], translateY: [20, 0], duration: 900 }, '-=500')
        .add({ targets: '.loader-rule', width: [0, 180], duration: 700, easing: 'easeInOutQuart' }, '-=400')
        .add({
          targets: '.loader-bar-wrap',
          opacity: [0, 1],
          duration: 400,
          complete: () => { loaderReady = true; maybeHide(); }
        }, '-=100');
    }

    const loaderInterval = setInterval(() => {
      const step = Math.random() * (progress < 60 ? 8 : progress < 85 ? 4 : 2);
      progress = Math.min(progress + step, 100);
      if (loaderBar) loaderBar.style.width = progress + '%';
      if (loaderPct) loaderPct.textContent = Math.floor(progress);
      if (progress >= 100) {
        clearInterval(loaderInterval);
        progressDone = true;
        maybeHide();
      }
    }, 80);

    function maybeHide() {
      if (!loaderReady || !progressDone) return;
      const elapsed = Date.now() - loaderStartTime;
      const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);
      setTimeout(hideLoader, remaining);
    }

    function hideLoader() {
      const hideTl = anime.timeline({ easing: 'easeInOutQuart' });
      hideTl.add({ targets: ['.loader-bar-wrap', '.loader-pct', '.loader-rule'], opacity: [1, 0], duration: 400 });

      if (hasLogoImg) {
        hideTl.add({ targets: '.loader-logo-img', opacity: [1, 0], translateY: [0, -20], duration: 600 }, '-=100');
      } else {
        hideTl
          .add({ targets: '.loader-n', opacity: [1, 0], translateY: [0, -30], duration: 600 }, '-=100')
          .add({ targets: '.loader-m', opacity: [1, 0], translateY: [0, -12], duration: 500 }, '-=400');
      }

      hideTl.add({
        targets: loader,
        opacity: [1, 0],
        duration: 700,
        complete: () => {
          loader.style.display = 'none';
          initHeroAnimation();
        }
      }, '-=200');
    }
  }

  // ================================================================
  //  CUSTOM CURSOR
  // ================================================================
  const dot  = document.getElementById('cursorDot');
  const ring = document.getElementById('cursorRing');

  if (dot && ring) {
    document.addEventListener('mousemove', (e) => {
      dot.style.left = e.clientX + 'px';
      dot.style.top  = e.clientY + 'px';
      anime({ targets: ring, left: e.clientX, top: e.clientY, duration: 220, easing: 'easeOutQuad' });
    });

    document.querySelectorAll('a, button, .runway-card, .arch-item, .store-card, .product-card, .tl-item').forEach(el => {
      el.addEventListener('mouseenter', () => { ring.classList.add('hover'); dot.classList.add('hover'); });
      el.addEventListener('mouseleave', () => { ring.classList.remove('hover'); dot.classList.remove('hover'); });
    });
  }

  // ================================================================
  //  MAGNETIC BUTTONS
  // ================================================================
  function initMagnetic(btn) {
    let naturalCenter = null;

    btn.addEventListener('mouseenter', () => {
      btn.style.transition = 'none';
      btn.style.removeProperty('transform');
      void btn.offsetWidth;
      const r = btn.getBoundingClientRect();
      naturalCenter = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    });

    btn.addEventListener('mousemove', (e) => {
      if (!naturalCenter) return;
      const x = (e.clientX - naturalCenter.x) * 0.28;
      const y = (e.clientY - naturalCenter.y) * 0.28;
      btn.style.transform = `translate(${x}px, ${y}px)`;
    });

    btn.addEventListener('mouseleave', () => {
      naturalCenter = null;
      btn.style.transition = 'transform 0.65s cubic-bezier(0.23, 1, 0.32, 1)';
      btn.style.removeProperty('transform');
      setTimeout(() => btn.style.removeProperty('transition'), 650);
    });
  }

  document.querySelectorAll('.magnetic').forEach(initMagnetic);

  // ================================================================
  //  PRIVATE COLLECTION — populate overlay from Liquid JSON data
  // ================================================================
  (function populatePrivateCollection() {
    const dataEl = document.getElementById('private-collection-data');
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const eyebrowEl  = document.getElementById('privateEyebrow');
    const titleEl    = document.getElementById('privateTitle');
    const subtitleEl = document.getElementById('privateSubtitle');
    const gridEl     = document.getElementById('privateGrid');
    const inquireBtn = document.getElementById('privateInquireBtn');

    if (eyebrowEl)  eyebrowEl.textContent  = data.eyebrow  || '';
    if (titleEl)    titleEl.textContent    = data.title    || '';
    if (subtitleEl) subtitleEl.textContent = data.subtitle || '';
    if (inquireBtn && data.contactUrl) inquireBtn.href = data.contactUrl;

    if (gridEl && Array.isArray(data.items)) {
      const activeItems = data.items.filter(item => item.name || item.price);
      gridEl.innerHTML = activeItems.map(item => {
        const bgStyle = item.photo
          ? ` style="background-image:url('${item.photo}');background-size:cover;background-position:center;"`
          : '';
        const priceHtml = item.price
          ? `<div class="pi-price">${item.price}</div>` : '';
        let actionHtml = '';
        if (item.available && item.variantId) {
          actionHtml = `<button class="pi-cart-btn magnetic" data-variant-id="${item.variantId}">Add to Cart</button>`;
        } else if (item.status) {
          actionHtml = `<div class="pi-status">${item.status}</div><a href="${data.contactUrl || '#contact'}" class="pi-inquire-btn">Inquire →</a>`;
        }
        return `<div class="priv-item">
          <div class="pi-visual piv${item.index}"${bgStyle}></div>
          <div class="pi-name">${item.name || ''}</div>
          ${priceHtml}${actionHtml}
        </div>`;
      }).join('');

      gridEl.querySelectorAll('.magnetic').forEach(initMagnetic);

      gridEl.querySelectorAll('.pi-cart-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const variantId = btn.dataset.variantId;
          if (variantId) addToCart(variantId, btn);
        });
      });
    }
  })();

  // ================================================================
  //  NAVIGATION — SCROLL HIDE / SHOW
  // ================================================================
  const nav = document.getElementById('nav');
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    nav.classList.toggle('scrolled', current > 80);
    if (current > lastScroll + 20 && current > 300) {
      nav.classList.add('hidden');
    } else if (current < lastScroll - 5) {
      nav.classList.remove('hidden');
    }
    lastScroll = current;
  });

  // ================================================================
  //  HERO ANIMATION
  // ================================================================
  function splitToChars(el) {
    const text = el.textContent.trim();
    el.innerHTML = text.split('').map(c =>
      `<span class="hero-char" aria-hidden="true">${c === ' ' ? '&nbsp;' : c}</span>`
    ).join('');
    el.setAttribute('aria-label', text);
  }

  function initHeroAnimation() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      ['#heroPre','#heroW1','#heroW2','#heroSub','#heroCta','#heroScroll','.hero-label-tl','.hero-label-br','.hero-edge-left'].forEach(sel => {
        document.querySelectorAll(sel).forEach(el => { el.style.opacity = 1; el.style.transform = 'none'; });
      });
      const div = document.querySelector('.hero-divider');
      if (div) div.style.width = '180px';
      return;
    }

    const w1 = document.getElementById('heroW1');
    const w2 = document.getElementById('heroW2');
    if (w1) splitToChars(w1);
    if (w2) splitToChars(w2);

    const tl = anime.timeline({ easing: 'easeOutExpo' });
    tl.add({ targets: '#heroPre', opacity: [0, 1], translateY: [12, 0], duration: 700 })
      .add({ targets: '#heroW1 .hero-char', opacity: [0, 1], translateY: [70, 0], rotateX: [40, 0], delay: anime.stagger(45), duration: 900, easing: 'easeOutExpo' }, '-=300')
      .add({ targets: '#heroW2 .hero-char', opacity: [0, 1], translateY: [70, 0], rotateX: [40, 0], delay: anime.stagger(45), duration: 900, easing: 'easeOutExpo' }, '-=750')
      .add({ targets: '.hero-divider', width: ['0px', '180px'], duration: 900, easing: 'easeInOutQuart' }, '-=500')
      .add({ targets: '#heroSub', opacity: [0, 1], translateY: [16, 0], duration: 700 }, '-=600')
      .add({ targets: '#heroCta', opacity: [0, 1], translateY: [16, 0], duration: 600 }, '-=450')
      .add({ targets: ['#heroScroll', '.hero-label-tl', '.hero-label-br', '.hero-edge-left'], opacity: [0, 1], duration: 700, delay: anime.stagger(80) }, '-=350');
  }

  if (!isHomepage) initHeroAnimation();

  // ================================================================
  //  SCROLL REVEAL
  // ================================================================
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = (el.dataset.index || 0) * 40;
        setTimeout(() => el.classList.add('visible'), delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.10, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  // ================================================================
  //  PARALLAX HERO
  // ================================================================
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const heroBg = document.querySelector('.hero-gradient');
    if (heroBg && y < window.innerHeight) {
      heroBg.style.transform = `translateY(${y * 0.25}px)`;
    }
  }, { passive: true });

  // ================================================================
  //  3D TILT — PRODUCT CARDS
  // ================================================================
  document.querySelectorAll('.tilt-card').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width  - 0.5;
      const y = (e.clientY - rect.top)  / rect.height - 0.5;
      card.style.transform = `perspective(1000px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) scale(1.02)`;
    });
    card.addEventListener('mouseleave', () => {
      anime({ targets: card, rotateX: 0, rotateY: 0, scale: 1, duration: 600, easing: 'easeOutElastic(1, 0.6)' });
    });
  });

  // ================================================================
  //  COUNTDOWN TIMER
  // ================================================================
  const countdownDataEl = document.getElementById('countdown-data');
  const dropDateStr = countdownDataEl ? countdownDataEl.dataset.date : null;
  const dropDate = (dropDateStr && !isNaN(new Date(dropDateStr))) ? new Date(dropDateStr) : (() => { const d = new Date(); d.setFullYear(d.getFullYear() + 1); return d; })();

  function updateCountdown() {
    const diff = dropDate - new Date();
    if (diff <= 0) return;
    const pad = n => String(Math.floor(n)).padStart(2, '0');
    const dEl = document.getElementById('cdDays');
    const hEl = document.getElementById('cdHours');
    const mEl = document.getElementById('cdMins');
    const sEl = document.getElementById('cdSecs');
    if (dEl) dEl.textContent = pad(diff / 86400000);
    if (hEl) hEl.textContent = pad((diff % 86400000) / 3600000);
    if (mEl) mEl.textContent = pad((diff % 3600000)  / 60000);
    if (sEl) sEl.textContent = pad((diff % 60000)    / 1000);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ================================================================
  //  SHOPIFY AJAX CART
  // ================================================================
  async function addToCart(variantId, btn) {
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      await refreshCart();
      openCartSidebar();
      btn.textContent = '✓ Added';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
    } catch (err) {
      btn.textContent = originalText;
      btn.disabled = false;
      console.error('Cart error:', err);
    }
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartSidebar(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('Cart fetch error:', err);
    }
  }

  function renderCartSidebar(cart) {
    const cartEmpty  = document.getElementById('cartEmpty');
    const cartItems  = document.getElementById('cartItems');
    const cartFooter = document.getElementById('cartFooter');
    const cartTotal  = document.getElementById('cartTotal');

    if (!cartItems) return;

    if (cart.item_count === 0) {
      cartItems.innerHTML = '';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = 'flex';
    } else {
      if (cartEmpty) cartEmpty.style.display = 'none';
      cartItems.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <div class="ci-info">
            <div class="ci-name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="ci-variant">${item.variant_title}</div>` : ''}
          </div>
          <div class="ci-right">
            <div class="ci-qty">× ${item.quantity}</div>
            <div class="ci-price">$${(item.final_line_price / 100).toFixed(0)}</div>
          </div>
        </div>
      `).join('');
      if (cartFooter) cartFooter.style.display = 'flex';
      if (cartTotal) cartTotal.textContent = '$' + (cart.total_price / 100).toFixed(0);
    }
  }

  function updateCartCount(count) {
    const countEl = document.getElementById('cartCount');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  // Initialize cart count on load
  refreshCart();

  // Add to cart buttons
  document.querySelectorAll('.sc-btn:not(.sc-btn--sold)').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId || variantId === 'YOUR_VARIANT_ID') {
        // Demo mode — open sidebar without adding real product
        openCartSidebar();
        return;
      }
      addToCart(variantId, btn);
    });
  });

  // Cart button in nav
  const cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCartSidebar);

  // ================================================================
  //  CART SIDEBAR OPEN / CLOSE
  // ================================================================
  const cartSidebar  = document.getElementById('cartSidebar');
  const cartBackdrop = document.getElementById('cartBackdrop');
  const cartClose    = document.getElementById('cartClose');

  function openCartSidebar() {
    if (!cartSidebar) return;
    cartSidebar.classList.add('open');
    if (cartBackdrop) cartBackdrop.classList.add('active');
    anime({ targets: '#cartSidebar', translateX: ['100%', '0%'], duration: 500, easing: 'easeOutExpo' });
  }

  function closeCart() {
    if (!cartSidebar) return;
    anime({
      targets: '#cartSidebar',
      translateX: ['0%', '100%'],
      duration: 400,
      easing: 'easeInQuart',
      complete: () => {
        cartSidebar.classList.remove('open');
        if (cartBackdrop) cartBackdrop.classList.remove('active');
      }
    });
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  // ================================================================
  //  EXCLUSIVE OFFER POPUP — triggers after 45s
  // ================================================================
  const popupOverlay = document.getElementById('popupOverlay');
  const popupClose   = document.getElementById('popupClose');
  const popupCta     = document.getElementById('popupCta');
  let popupShown = false;

  function showPopup() {
    if (popupShown || !popupOverlay) return;
    popupShown = true;
    popupOverlay.classList.add('active');
    anime({ targets: '#popupBox', scale: [0.95, 1], opacity: [0, 1], duration: 700, easing: 'easeOutExpo' });
  }

  setTimeout(showPopup, 45000);

  if (popupClose) {
    popupClose.addEventListener('click', () => {
      anime({
        targets: '#popupBox', scale: [1, 0.97], opacity: [1, 0], duration: 400, easing: 'easeInQuart',
        complete: () => { if (popupOverlay) popupOverlay.classList.remove('active'); }
      });
    });
  }

  if (popupCta) popupCta.addEventListener('click', () => { if (popupOverlay) popupOverlay.classList.remove('active'); });

  // ================================================================
  //  UNLOCK PRIVATE COLLECTION
  // ================================================================
  const unlockBtn      = document.getElementById('unlockBtn');
  const privateOverlay = document.getElementById('privateOverlay');
  const privateClose   = document.getElementById('privateClose');

  if (unlockBtn) {
    unlockBtn.addEventListener('click', () => {
      if (!privateOverlay) return;
      privateOverlay.classList.add('active');
      anime({ targets: '.private-grid .priv-item', opacity: [0, 1], translateY: [20, 0], delay: anime.stagger(100, { start: 300 }), duration: 600, easing: 'easeOutExpo' });
    });
  }

  if (privateClose) {
    privateClose.addEventListener('click', () => {
      anime({
        targets: '#privateBox', opacity: [1, 0], translateY: [0, 20], duration: 400, easing: 'easeInQuart',
        complete: () => { if (privateOverlay) privateOverlay.classList.remove('active'); }
      });
    });
  }

  // ================================================================
  //  NOTIFY BUTTON
  // ================================================================
  const notifyBtn = document.getElementById('notifyBtn');
  if (notifyBtn) {
    notifyBtn.addEventListener('click', () => {
      notifyBtn.textContent = '✓ You\'re on the list';
      notifyBtn.style.borderColor = 'rgba(255,255,255,0.4)';
      notifyBtn.style.color = '#ffffff';
      anime({ targets: notifyBtn, scale: [1, 1.05, 1], duration: 400, easing: 'easeOutElastic(1, 0.6)' });
    });
  }

  // ================================================================
  //  CONTACT FORM (Shopify handles submission natively)
  // ================================================================
  const inquiryForm = document.getElementById('inquiryForm');
  if (inquiryForm) {
    inquiryForm.addEventListener('submit', () => {
      const btn = inquiryForm.querySelector('.btn-submit');
      if (btn) {
        const txt = btn.querySelector('.submit-text');
        if (txt) txt.textContent = 'Sending...';
        anime({ targets: btn, scale: [1, 1.03, 1], duration: 500, easing: 'easeOutElastic(1, 0.5)' });
      }
    });
  }

  // ================================================================
  //  AUDIO TOGGLE (UI only)
  // ================================================================
  const audioBtn   = document.getElementById('audioBtn');
  const audioLabel = document.getElementById('audioLabel');
  let audioOn = false;

  if (audioBtn) {
    audioBtn.addEventListener('click', () => {
      audioOn = !audioOn;
      if (audioLabel) audioLabel.textContent = audioOn ? 'Mute' : 'Sound';
      audioBtn.setAttribute('aria-pressed', audioOn);
    });
  }

  // ================================================================
  //  RUNWAY CARDS — HOVER EFFECT
  // ================================================================
  document.querySelectorAll('.runway-card').forEach(card => {
    const name = card.querySelector('.rv-name');
    if (!name) return;
    card.addEventListener('mouseenter', () => anime({ targets: name, translateX: [0, 4], duration: 300, easing: 'easeOutQuad' }));
    card.addEventListener('mouseleave', () => anime({ targets: name, translateX: [4, 0], duration: 300, easing: 'easeOutQuad' }));
  });

  // ================================================================
  //  TIMELINE INTERACTION
  // ================================================================
  document.querySelectorAll('.tl-item').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.tl-item').forEach(t => t.classList.remove('active'));
      item.classList.add('active');
    });
  });

  // ================================================================
  //  VIDEO PROOF — parse YouTube/Vimeo URLs and inject iframes
  // ================================================================
  function getVideoEmbed(url) {
    if (!url) return null;
    if (/\.(mp4|mov|webm|ogg)(\?.*)?$/i.test(url)) return { type: 'video', src: url };
    const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (ytMatch) return { type: 'iframe', src: `https://www.youtube.com/embed/${ytMatch[1]}?rel=0&modestbranding=1` };
    const vmMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vmMatch) return { type: 'iframe', src: `https://player.vimeo.com/video/${vmMatch[1]}?color=ffffff&title=0&byline=0&portrait=0` };
    return null;
  }

  document.querySelectorAll('.pv-iframe-holder[data-video-url]').forEach(holder => {
    const result = getVideoEmbed(holder.dataset.videoUrl);
    if (!result) return;
    holder.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;';
    if (result.type === 'video') {
      holder.innerHTML = `<video controls muted playsinline preload="metadata" style="width:100%;height:100%;object-fit:contain;background:#000;"><source src="${result.src}" type="video/mp4"></video>`;
    } else {
      holder.innerHTML = `<iframe src="${result.src}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy" style="width:100%;height:100%;border:none;"></iframe>`;
    }
  });

  // ================================================================
  //  FAQ ACCORDION
  // ================================================================
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        el.querySelector('.faq-a').setAttribute('aria-hidden', 'true');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.faq-a').setAttribute('aria-hidden', 'false');
      }
    });
  });

  // ================================================================
  //  SMOOTH SCROLL FOR ANCHOR LINKS
  // ================================================================
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ================================================================
  //  KONAMI CODE EASTER EGG
  // ================================================================
  const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  let konamiIdx = 0;
  const easterNotif = document.getElementById('easterNotif');

  document.addEventListener('keydown', (e) => {
    if (e.key === KONAMI[konamiIdx]) {
      konamiIdx++;
      if (konamiIdx === KONAMI.length) {
        konamiIdx = 0;
        if (easterNotif) {
          easterNotif.classList.add('show');
          setTimeout(() => easterNotif.classList.remove('show'), 5000);
        }
        if (!popupShown) showPopup();
      }
    } else { konamiIdx = 0; }
  });

  // ================================================================
  //  LOGO CLICK EASTER EGG (5×)
  // ================================================================
  const navLogo = document.querySelector('.nav-logo');
  let logoClicks = 0;
  if (navLogo) {
    navLogo.addEventListener('click', (e) => {
      e.preventDefault();
      logoClicks++;
      if (logoClicks >= 5) {
        logoClicks = 0;
        if (easterNotif) {
          easterNotif.classList.add('show');
          setTimeout(() => easterNotif.classList.remove('show'), 5000);
        }
      }
    });
  }

  // ================================================================
  //  SCROLL PROGRESS BAR
  // ================================================================
  const progressBar = document.getElementById('scrollProgress');
  window.addEventListener('scroll', () => {
    const total = document.body.scrollHeight - window.innerHeight;
    if (progressBar) progressBar.style.width = ((window.scrollY / total) * 100) + '%';
  }, { passive: true });

  // ================================================================
  //  MOBILE MENU
  // ================================================================
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileNav     = document.getElementById('mobileNav');
  let menuOpen = false;

  window.closeMobileMenu = function() {
    menuOpen = false;
    if (mobileMenuBtn) { mobileMenuBtn.classList.remove('open'); mobileMenuBtn.setAttribute('aria-expanded', 'false'); }
    if (mobileNav) { mobileNav.classList.remove('active'); mobileNav.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  };

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', () => {
      menuOpen = !menuOpen;
      mobileMenuBtn.classList.toggle('open', menuOpen);
      mobileMenuBtn.setAttribute('aria-expanded', menuOpen);
      if (mobileNav) {
        mobileNav.classList.toggle('active', menuOpen);
        mobileNav.setAttribute('aria-hidden', !menuOpen);
      }
      document.body.style.overflow = menuOpen ? 'hidden' : '';

      if (menuOpen) {
        anime({
          targets: '.mobile-nav-link',
          opacity: [0, 1],
          translateY: [20, 0],
          delay: anime.stagger(70, { start: 100 }),
          duration: 500,
          easing: 'easeOutExpo'
        });
      }
    });
  }

  // ================================================================
  //  AMBIENT TEXT SHIMMER
  // ================================================================
  setInterval(() => {
    if (document.getElementById('heroW2')) {
      anime({ targets: '#heroW2', opacity: [1, 0.75, 1], duration: 3000, easing: 'easeInOutSine' });
    }
  }, 8000);

});
